import { apiProxyRequest } from "Api/apiProxyRequest";

import type { Variable } from "./types";
import type { Activity } from "Api/activity/types";

export const deleteEnvironmentVariableRequest = (variable: Variable) =>
  apiProxyRequest<{
    status: string;
    code: number;
    _embedded: {
      activities: Activity[];
    };
  }>(`${variable?._links?.["#delete"]?.href}`, "DELETE");
